import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';

import { LanguagesCode } from 'src/i18n/constants';

interface LanguageState {
    language: LanguagesCode;
}

const initialState: LanguageState = {
    language: LanguagesCode.English,
};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<LanguagesCode>) => {
            state.language = action.payload;
        },
    },
});

export const { setLanguage } = languageSlice.actions;

const selectLanguageState = (state: { language: LanguageState }) => state.language;

export const selectLanguage = createSelector(
    [selectLanguageState],
    (languageState) => languageState.language
);

export default languageSlice.reducer;
